// AYUSHLicenseRegistration.jsx
import React from "react";

export default function AYUSHLicenseRegistration() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            AYUSH License
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            AYUSH License Registration Support
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks supports AYUSH License registration for
            manufacturers and marketers of Ayurveda, Unani, Siddha, and
            Homeopathy products, helping them meet licensing norms before
            launching or scaling operations.[web:201][web:202]
          </p>
          <p className="text-gray-700">
            The process covers documentation, application filing, and support
            during scrutiny or inspection, so that facilities, staff, and
            products align with AYUSH regulatory expectations from the outset.[web:201][web:203]
          </p>
        </div>

        {/* Right: Image (square) */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/161477/massage-therapist-medicine-physiotherapy-161477.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="AYUSH practitioner and herbal products representing traditional medicine licensing"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required for AYUSH License
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks helps applicants gather and structure the
              key business, premises, staff, and product documents that AYUSH
              departments typically require for licensing.[web:201][web:202]
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>
                  Business registration documents such as incorporation
                  certificate, partnership deed, or proprietorship proof,
                  together with PAN and basic KYC details.[web:202][web:204]
                </li>
                <li>
                  Manufacturing unit details, including premises ownership or
                  lease proof, layout plan, list of machinery and equipment, and
                  indication that the unit is on appropriate industrial or
                  approved land.[web:201][web:207]
                </li>
                <li>
                  Technical staff qualifications and experience details,
                  particularly of responsible Ayurvedic/Unani/Siddha/
                  Homeopathic experts and production or quality heads.[web:201][web:203]
                </li>
                <li>
                  Product list with basic formulation details, proposed dosage
                  forms, and, where required, specifications or formula sheets
                  to demonstrate compliance with recognized AYUSH texts.[web:202][web:204]
                </li>
                <li>
                  Any additional declarations, GMP-related documents, or prior
                  manufacturing approvals that may be requested depending on the
                  specific license category.[web:201][web:202]
                </li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              The firm offers sector-focused support for traditional medicine
              businesses, aligning documentation and processes with AYUSH
              regulatory requirements.[web:201][web:203]
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Expertise in AYUSH Regulations
                </h3>
                <p className="text-gray-700 text-sm">
                  Guidance on license types, documentation standards, and key
                  conditions under the AYUSH framework so that facilities and
                  products stay within regulatory expectations.[web:201][web:205]
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Accurate and Compliant Filings
                </h3>
                <p className="text-gray-700 text-sm">
                  Support in preparing forms, annexures, and technical details
                  accurately, reducing the risk of queries, delays, or
                  rejections during license scrutiny.[web:201][web:203]
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Dedicated Professional Assistance
                </h3>
                <p className="text-gray-700 text-sm">
                  End-to-end assistance from documentation and filing to
                  follow-up and clarifications, offering continuous support as
                  the AYUSH license application moves through review.[web:202][web:203]
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
